module.exports = __webpack_public_path__ + "static/media/icon_banner.4c258475.png";